module.exports = __webpack_public_path__ + "img/team_meiling2.e6fc6560.jpg";